<template>
  <cube-page title="分级客户购进情况">
    <div slot="content">
      <div v-if="ddiDate && monthDate"
           class="date">
        <span class="text">{{ currentYearStr + ' 至 ' + ddiDate.format("YYYY-MM-DD") }}</span>
      </div>
      <div class="navBar">
        <cube-scroll-nav-bar :current="current"
                             :labels="labels"
                             :txts="txts"
                             @change="handleClick"
                             class="scrollNav" />
      </div>
      <wmq-layout v-show="current === 'primaryBusinessFlag'"
                  ref="一级商业"
                  :rootLayoutConfig="configData" />
      <wmq-layout v-show="current === 'secondaryBusinessFlag'"
                  ref="二级商业"
                  :rootLayoutConfig="secondaryConfigData" />
      <wmq-layout v-show="
                    current === 'longmu60RootFlag'
                  "
                  ref="KA连锁"
                  :rootLayoutConfig="kaUiConfigData" />
      <wmq-layout v-show="
                    current === 'longmu30ControlRootFlag' ||
                      current === 'longmu30NotControlRootFlag'
                  "
                  ref="连锁"
                  :rootLayoutConfig="chainUiConfigData" />
    </div>
  </cube-page>
</template>

<script>
import uiConfig from '@/config/ui-config/channel-business-ui-config'
import secondaryUiConfig from '@/config/ui-config/channel-secondary-business-ui-config'
import chainUiConfig from '@/config/ui-config/channel-chain-ui-config'
import kaUiConfig from '@/config/ui-config/channel-ka-ui-config'
import { biData } from '@/api/cube'
import { getFlowTime } from '@/api/bigCustomer'
import { CubeDataHandle, WmqDashboardCubeDataHelperMixin } from 'wmq-component'
import { get, has, isEmpty, set } from 'lodash'
import CubePage from '../../components/cube-page'
import moment from 'moment'
export default {
  name: 'Channel',
  components: { CubePage },
  mixins: [WmqDashboardCubeDataHelperMixin],
  data () {
    return {
      current: 'primaryBusinessFlag',
      txts: ['一级商业', '二级商业', 'KA连锁', '协议连锁', '非协议连锁'],
      labels: [
        'primaryBusinessFlag',
        'secondaryBusinessFlag',
        'longmu60RootFlag',
        'longmu30ControlRootFlag',
        'longmu30NotControlRootFlag'
      ],
      ddiDate: undefined,
      currentYearStr: undefined,
      monthDate: undefined
    }
  },
  mounted () {
    getFlowTime().then((res) => {
      this.ddiDate = moment(res.data.ddiMaxDay || res.data.monthMaxDay)
      this.currentYearStr = this.ddiDate.format('YYYY') + '-01-01'
      this.monthDate = moment(res.data.monthMaxDay)
      this.$refs['一级商业'].refreshAll()
    })
  },
  computed: {
    refName () {
      if (this.current === 'primaryBusinessFlag') {
        return '一级商业'
      } else if (this.current === 'secondaryBusinessFlag') {
        return '二级商业'
      } else if (this.current === 'longmu60RootFlag') {
        return 'KA连锁'
      } else {
        return '连锁'
      }
    },
    kaUiConfigData () {
      set(kaUiConfig, 'children.0.children.0.props.options.conditions', {
        text: [
          {
            field: 'dragonPurchaseNumber_YOY_R',
            mapping: this.filedMap
          },
          {
            field: 'dragonFreebieAfterNumber_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 130
      set(kaUiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return kaUiConfig
    },
    chainUiConfigData () {
      set(chainUiConfig, 'children.0.children.0.props.options.conditions', {
        text: [
          {
            field: 'dragonPurchaseNumber_YOY_R',
            mapping: this.filedMap
          },
          {
            field: 'dragonFreebieAfterNumber_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 130
      set(chainUiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return chainUiConfig
    },
    configData () {
      set(uiConfig, 'children.0.children.0.props.options.conditions', {
        text: [
          {
            field: 'cumulativeCompletionAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 130
      set(uiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return uiConfig
    },
    secondaryConfigData () {
      set(secondaryUiConfig, 'children.0.children.0.props.options.conditions', {
        text: [
          {
            field: 'cumulativeCompletionAmount_YOY_R',
            mapping: this.filedMap
          }
        ]
      })
      const height = document.body.clientHeight - 130
      set(secondaryUiConfig, 'schema.0.children.明细数据.layout.pos.h', height)
      return secondaryUiConfig
    }
  },
  provide () {
    const that = this
    return {
      requestHandler: function (data, reqObj) {
        reqObj.buyerBusinessLevel = that.current
        if (get(reqObj, 'date') === '__date__') {
          reqObj.date = that.ddiDate.format('YYYY-MM-DD')
        }
        if (that.current === 'primaryBusinessFlag') {
          reqObj.sellerBusinessLevel = ['jianminGroupFlag']
        } else if (that.current === 'secondaryBusinessFlag') {
          reqObj.sellerBusinessLevel = ['primaryBusinessFlag', 'jianminGroupFlag']
        }
        // const name = that.current
        return biData(data.dataCode, reqObj).then(res => {
          return new Promise((resolve) => {
            resolve(CubeDataHandle.handleCubeData(res.data))
          })
        })
      }
    }
  },
  methods: {
    pushUserLog (text) {
      this.$store.dispatch('PushUserLog', {
        menu: '渠道',
        page: '分级客户购进情况',
        operation: '切换Tab'
      })
    },
    handleClick (cur) {
      this.current = cur
      this.$nextTick(() => {
        this.$refs[this.refName].refreshAll()
      })
      this.pushUserLog()
    },
    filedMap (fieldValue) {
      if (fieldValue && fieldValue.indexOf('-') > -1) {
        return {
          fill: 'red'
        }
      }
      return { fill: '#333333' }
    },
    onRequest (reqParams) {
      const name = this.current
      this.handleDataEvent(
        this.$refs[this.refName],
        reqParams,
        (dataCodes, reqObj) => {
          reqObj.buyerBusinessLevel = this.current
          if (has(reqObj, 'date') && isEmpty(get(reqObj, 'date'))) {
            reqObj.date = this.ddiDate.format('YYYY-MM-DD')
          }
          if (this.current === 'primaryBusinessFlag') {
            reqObj.sellerBusinessLevel = ['jianminGroupFlag']
          } else if (this.current === 'secondaryBusinessFlag') {
            reqObj.sellerBusinessLevel = ['primaryBusinessFlag', 'jianminGroupFlag']
          }
          return biData(dataCodes, reqObj).then((res) => {
            if (reqObj.buyerBusinessLevel !== name) {
              return {}
            }
            return new Promise((resolve) => {
              resolve(res)
            })
          })
        }
      )
    }
  }
}
</script>

<style lang="stylus" scoped>
.date
  font-size 18px
  color #666666
  padding 30px 30px 0px 30px
  .text
    margin 0px 10px
</style>
<style lang="stylus">
.navBar
  margin-bottom 10px
  .scrollNav
    .cube-scroll-wrapper .cube-scroll-nav-bar-item
      padding 20px 18px
</style>
